// Bundler alias target for `metabase-lib/v1/parameters/constants` (see
// `ias-aliases.js`). Tells dashboard editors which text operators take range
// values (`1Q110:1Q200`): "Is" and "Is not" get an editor-only `menuName`,
// shown in the filter operator picker; their `name`, shown to viewers, is
// unchanged. Labels stay getters so they translate after the locale loads.
// The upstream module is imported by relative path to avoid an alias cycle.

import { t } from "ttag";

import { PARAMETER_OPERATOR_TYPES as UPSTREAM_PARAMETER_OPERATOR_TYPES } from "../../metabase-lib/v1/parameters/constants";

export * from "../../metabase-lib/v1/parameters/constants";

const RANGE_MENU_NAMES: Partial<Record<string, () => string>> = {
  "string/=": () => t`Is (accepts ranges)`,
  "string/!=": () => t`Is not (accepts ranges)`,
};

export const PARAMETER_OPERATOR_TYPES = {
  ...UPSTREAM_PARAMETER_OPERATOR_TYPES,
  string: UPSTREAM_PARAMETER_OPERATOR_TYPES.string.map((option) => {
    const getMenuName = RANGE_MENU_NAMES[option.type];
    if (getMenuName == null) {
      return option;
    }
    return {
      type: option.type,
      operator: option.operator,
      get name() {
        return option.name;
      },
      get description() {
        return option.description;
      },
      get menuName() {
        return getMenuName();
      },
    };
  }),
};
